import styled from 'styled-components';
import colors from '../../../helpers/colors';
import fonts from '../../../helpers/fonts';
import spacing from '../../../helpers/spacing';
import { underlineOnFocus, underlineOnValue } from '../InputUnderline';

export const Container = styled.div`
  display: flex;
  position: relative;
`;
export const InputCharacterCount = styled.div`
  display: flex;
  position: relative;
  justify-content: flex-end;
  ${fonts.paragraph};
`;

export const StyledTextAreaInput = styled.textarea`
  width: 100%;
  height: ${spacing(14)};
  resize: vertical;
  overflow: auto;

  padding: ${spacing(2)};

  ${fonts.paragraph};

  border: 1px solid ${colors.neutral03};
  border-radius: ${({ theme }) => theme.inputRadius};

  ::-ms-clear {
    display: none;
  }

  &:focus-visible {
    outline: none;
  }

  ${underlineOnFocus}
  ${underlineOnValue}
`;
